import { render } from "./chatbot.vue?vue&type=template&id=6bea80f5&scoped=true"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"

import "./chatbot.vue?vue&type=style&index=0&id=6bea80f5&scoped=true&lang=css"
import "./chatbot.vue?vue&type=style&index=1&id=6bea80f5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bea80f5"]])

export default __exports__